import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { getApplications, updateAppStatus } from '../services/api';

const statusColors = {
  pending:     { bg: '#fff8e6', color: '#f59e0b' },
  reviewed:    { bg: '#e8f0ff', color: '#0066FF' },
  shortlisted: { bg: '#e6fff6', color: '#00C896' },
  rejected:    { bg: '#fff0f0', color: '#ef4444' },
  hired:       { bg: '#e6fff6', color: '#00C896' },
};

export default function Applications() {
  const [apps, setApps]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState('all');

  useEffect(() => {
    getApplications()
      .then(data => { setApps(data.applications || data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const handleStatus = async (id, status) => {
    await updateAppStatus(id, status);
    setApps(apps.map(a => a._id === id ? { ...a, status } : a));
  };

  const filtered = filter === 'all' ? apps : apps.filter(a => a.status === filter);

  return (
    <Layout>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontWeight: 800, color: '#0A1628', margin: '0 0 4px' }}>Applications</h2>
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>{apps.length} total applications</p>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {['all', 'pending', 'reviewed', 'shortlisted', 'hired', 'rejected'].map(s => (
          <button key={s} onClick={() => setFilter(s)} style={{ padding: '8px 16px', borderRadius: 10, border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer', background: filter === s ? '#0066FF' : '#fff', color: filter === s ? '#fff' : '#555', boxShadow: filter === s ? '0 4px 12px rgba(0,102,255,0.25)' : '0 2px 8px rgba(0,0,0,0.05)' }}>
            {s.charAt(0).toUpperCase() + s.slice(1)}
          </button>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: 16, border: '1.5px solid #eef0f8', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8faff' }}>
              {['Applicant', 'Job', 'Applied On', 'Status', 'Update Status'].map(h => (
                <th key={h} style={{ padding: '14px 20px', textAlign: 'left', fontSize: 12, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}><i className="fa fa-spinner fa-spin me-2"></i>Loading...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={5} style={{ padding: '32px', textAlign: 'center', color: '#aaa' }}>No applications found</td></tr>
            ) : filtered.map((a) => (
              <tr key={a._id} style={{ borderTop: '1px solid #f5f5f5' }}>
                <td style={{ padding: '14px 20px' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0A1628' }}>{a.applicant?.name || 'N/A'}</div>
                  <div style={{ fontSize: 11, color: '#aaa' }}>{a.applicant?.email}</div>
                </td>
                <td style={{ padding: '14px 20px' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0A1628' }}>{a.job?.title || 'N/A'}</div>
                  <div style={{ fontSize: 11, color: '#aaa' }}>{a.job?.company}</div>
                </td>
                <td style={{ padding: '14px 20px', fontSize: 13, color: '#888' }}>{new Date(a.createdAt).toLocaleDateString()}</td>
                <td style={{ padding: '14px 20px' }}>
                  <span style={{ fontSize: 11, fontWeight: 700, padding: '4px 12px', borderRadius: 50, background: statusColors[a.status]?.bg, color: statusColors[a.status]?.color }}>
                    {a.status?.charAt(0).toUpperCase() + a.status?.slice(1)}
                  </span>
                </td>
                <td style={{ padding: '14px 20px' }}>
                  <select value={a.status} onChange={e => handleStatus(a._id, e.target.value)}
                    style={{ padding: '6px 12px', borderRadius: 8, border: '1.5px solid #eef0f8', fontSize: 12, fontWeight: 600, cursor: 'pointer', outline: 'none', background: '#fafbff' }}>
                    {['pending', 'reviewed', 'shortlisted', 'hired', 'rejected'].map(s => (
                      <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
